/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Select_For_DebtInputs */

const vi_customer_select_for_debt = /** @type {(inputs: Customer_Select_For_DebtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn khách hàng để ghi công nợ`)
};

/**

* @param {Customer_Select_For_DebtInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_select_for_debt = /** @type {((inputs?: Customer_Select_For_DebtInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Select_For_DebtInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_select_for_debt(inputs)
});